import { CalendarPage } from './CalendarPage';

export function Calendar() {
  return <CalendarPage />;
}
